// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"f65be896","614":"7662eca3","774":"360f029a"}[chunkId] + ".chunk.css";
};